'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index$1 = require('./index-c3c373ce.js');

var activeStyles = {
    true: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    p {\n      color: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    p {\n      color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }),
    false: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    p {\n      color: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    p {\n      color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyLight;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminBlack;
    }),
};
var Container = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 16px;\n  width: 100%;\n  ", "\n  cursor: pointer;\n  box-sizing: border-box;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 16px;\n  width: 100%;\n  ", "\n  cursor: pointer;\n  box-sizing: border-box;\n"])), function (_a) {
    var active = _a.active;
    return activeStyles[active.toString()];
});
var Option = styled__default.p(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  margin: 0;\n"], ["\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var Icon = styled__default.span(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  margin-right: 4px;\n  color: ", ";\n\n  &.active {\n    color: ", ";\n  }\n"], ["\n  margin-right: 4px;\n  color: ", ";\n\n  &.active {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.palette.systemGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.palette.sharedWhite;
});
var ICONS = {
    editPencil: 'edit',
    moveTo: 'drive_file_move',
};
var HqOVisibleSelectItem = function (_a) {
    var active = _a.active, id = _a.id, iconName = _a.iconName, iconClassName = _a.iconClassName, onClickCallback = _a.onClickCallback, text = _a.text, onDoubleClick = _a.onDoubleClick;
    var handleClick = React.useCallback(function (event) {
        if (event.detail === 1 && onClickCallback) {
            onClickCallback(id, event);
        }
        else if (event.detail === 2 && onDoubleClick) {
            onDoubleClick(event);
        }
    }, [id, onClickCallback, onDoubleClick]);
    return (React__default.createElement(Container, { active: active, onClick: handleClick, onDoubleClick: handleClick, "data-testid": "hqo-visible-select-item" },
        iconName && (React__default.createElement(Icon, { className: index$1.classnames('material-icons', iconClassName, { active: active }), "data-testid": "hqo-visible-select-item-icon" }, ICONS[iconName] || iconName)),
        React__default.createElement(Option, null, text)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var Container$1 = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  max-height: 248px;\n  overflow-y: auto;\n  gap: 8px;\n"], ["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  max-height: 248px;\n  overflow-y: auto;\n  gap: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
});
var HqOVisibleSelect = function (_a) {
    var options = _a.options, onSelect = _a.onSelect, onDoubleClick = _a.onDoubleClick;
    return (React__default.createElement(Container$1, { "data-testid": "hqo-visible-select", className: "context-menu-select" }, options === null || options === void 0 ? void 0 : options.map(function (option) { return (React__default.createElement(HqOVisibleSelectItem, { key: option.id, active: option.active, iconName: option.iconName, iconClassName: option.iconClassName, id: option.id, onClickCallback: onSelect, text: option.text, onDoubleClick: onDoubleClick })); })));
};
var templateObject_1$1;

exports.HqOVisibleSelect = HqOVisibleSelect;
